/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ticketpageordercount3Inputs */

const en_ticketpageordercount3 = /** @type {(inputs: Ticketpageordercount3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} orders in total`)
};

const de_ticketpageordercount3 = /** @type {(inputs: Ticketpageordercount3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Bestellungen insgesamt`)
};

/**
* | output |
* | --- |
* | "{count} orders in total" |
*
* @param {Ticketpageordercount3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpageordercount3 = /** @type {((inputs: Ticketpageordercount3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpageordercount3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpageordercount3(inputs)
	return de_ticketpageordercount3(inputs)
});
export { ticketpageordercount3 as "ticketPageOrderCount" }